









import { Component, Prop, Vue } from 'vue-property-decorator';
import ClassItemRate from '../../../models/interfaces/ClassItemRate';
import ClassItem from '../../../models/interfaces/ClassItem';
import likeDislike from './likeDislike.vue';

@Component({ components: { likeDislike } })
export default class ClassLikeDislike extends Vue {
  @Prop({ required: true })
  public readonly item!: ClassItem;

  @Prop({ required: true, type: Object, default: () => ({}) })
  public readonly value!: ClassItemRate;

  public like: boolean = null;

  public updateLike(like: boolean) {
    if (this.value.like === true) this.value.score = 1;
    if (this.value.like === false) this.value.score = -1;
    if (this.value.like === null) this.value.score = 0;
    this.$emit('input', this.value);
  }
}
